"use strict";

var _classCallCheck = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var config_1 = require("./config");

var levels = ['debug', 'info', 'warn', 'error', 'none'];
var levelToInt = {};
var intToLevel = {};

for (var index = 0; index < levels.length; index++) {
  var level = levels[index];
  levelToInt[level] = index;
  intToLevel[index] = level;
}
/**
* @ignore
*/


var Logger =
/*#__PURE__*/
function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, null, [{
    key: "error",
    value: function error(message) {
      if (!this.shouldLog('error')) return;
      console.error(this.logMessage('error', message));
    }
  }, {
    key: "warn",
    value: function warn(message) {
      if (!this.shouldLog('warn')) return;
      console.warn(this.logMessage('warn', message));
    }
  }, {
    key: "info",
    value: function info(message) {
      if (!this.shouldLog('info')) return;
      console.log(this.logMessage('info', message));
    }
  }, {
    key: "debug",
    value: function debug(message) {
      if (!this.shouldLog('debug')) return;
      console.log(this.logMessage('debug', message));
    }
  }, {
    key: "logMessage",
    value: function logMessage(level, message) {
      return "[".concat(level.toUpperCase(), "] ").concat(message);
    }
  }, {
    key: "shouldLog",
    value: function shouldLog(level) {
      var currentLevel = levelToInt[config_1.config.logLevel];
      return currentLevel <= levelToInt[level];
    }
  }]);

  return Logger;
}();

exports.Logger = Logger;